import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock, X } from 'lucide-react';
interface InspectionNotificationProps {
  orderName: string;
  minutesRemaining: number;
  isVisible: boolean;
  onClose: () => void;
}
export function InspectionNotification({
  orderName,
  minutesRemaining,
  isVisible,
  onClose
}: InspectionNotificationProps) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);
  return <AnimatePresence data-id="element-89">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: -20,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -10,
      scale: 0.95
    }} transition={{
      duration: 0.2,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed top-4 right-4 z-[100]" data-id="element-90">
          <div className="bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden w-[280px]" data-id="element-91">
            <div className="px-3 py-2 flex items-center justify-between gap-2" data-id="element-92">
              <div className="flex items-center gap-2 flex-1 min-w-0" data-id="element-93">
                <Clock className="w-3.5 h-3.5 text-blue-600 flex-shrink-0" strokeWidth={2} data-id="element-94" />
                <div className="flex-1 min-w-0" data-id="element-95">
                  <p className="text-xs font-medium text-gray-900 truncate" data-id="element-96">
                    {orderName}
                  </p>
                  <p className="text-xs text-gray-600" data-id="element-97">
                    in{' '}
                    <strong className="text-blue-600" data-id="element-98">
                      {minutesRemaining} Min.
                    </strong>
                  </p>
                </div>
              </div>
              <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded transition-colors flex-shrink-0" aria-label="Schließen" data-id="element-99">
                <X className="w-3.5 h-3.5 text-gray-500" strokeWidth={2} data-id="element-100" />
              </button>
            </div>

            {/* Progress bar */}
            <motion.div initial={{
          width: '100%'
        }} animate={{
          width: '0%'
        }} transition={{
          duration: 5,
          ease: 'linear'
        }} className="h-0.5 bg-blue-500" data-id="element-101" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}